module.exports = __webpack_public_path__ + "img/ring_y_0_0_null@3x.dd820108.png";